export const VIRTUAL_PAGE_VIEW = 'virtualPageview';
export const TABLE_LOAD_TIME = 'tableLoadTime';
export const USABILITY = 'usability';
export const VISIBLE = 'visible';
export const USER = 'user';
export const NOTIFICATION = 'notification';
